<div
  class="h-full w-full overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
>
  <!-- encabezado: estado, tiempo, distancia y acciones -->
  <div
    class="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-gray-100 px-4 py-3 dark:border-gray-700"
  >
    <span
      class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-semibold text-white shadow-sm"
      [style.background]="pill.color"
    >
      <i [class]="pill.icon" class="text-xs"></i>{{ signal.onu_status }}
    </span>
    <div class="flex flex-col leading-tight">
      <span
        class="text-base font-semibold text-gray-800 dark:text-gray-100"
        [title]="sinceDate ? 'Desde ' + (sinceDate | date: 'dd/MM/yyyy HH:mm:ss') : signal.last_status_change"
      >
        {{ duration }}
      </span>
      <span class="whitespace-nowrap text-[11px] uppercase tracking-wide text-gray-400"
        >en este estado</span
      >
    </div>
    @if (distance) {
    <div class="flex flex-col leading-tight">
      <span class="text-base font-semibold text-gray-800 dark:text-gray-100">
        <i class="pi pi-map-marker text-xs text-gray-400"></i> {{ distance }}
      </span>
      <span class="text-[11px] uppercase tracking-wide text-gray-400">distancia</span>
    </div>
    }

    <div class="ml-auto flex items-center gap-2">
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 text-gray-500 transition disabled:opacity-50 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-600 dark:hover:bg-gray-700"
        title="Leer estado y óptica desde la OLT"
        [disabled]="loading"
        (click)="readOptics()"
      >
        <i class="pi pi-refresh text-sm" [class.pi-spin]="loading"></i>
      </button>
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 text-gray-500 transition hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-600 dark:hover:bg-gray-700"
        title="Tráfico en vivo"
        (click)="trafficLive.emit()"
      >
        <i class="pi pi-chart-line text-sm"></i>
      </button>
      <button
        type="button"
        class="flex h-8 min-w-[4.5rem] items-center justify-center gap-1.5 rounded-full px-3 text-xs font-bold uppercase tracking-wide shadow-sm transition"
        [ngClass]="
          liveRemaining
            ? 'border border-gray-300 bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-100'
            : 'bg-[#1fb325] text-white hover:brightness-110'
        "
        [title]="liveRemaining ? 'Detener la lectura en vivo' : 'Leer la óptica en vivo durante 60 s'"
        (click)="toggleLive()"
      >
        @if (liveRemaining) {
        <span class="relative flex h-2 w-2">
          <span
            class="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1fb325] opacity-75"
          ></span>
          <span class="relative inline-flex h-2 w-2 rounded-full bg-[#1fb325]"></span>
        </span>
        <span class="tabular-nums">{{ liveRemaining }}s</span>
        } @else {
        <i class="pi pi-heart-fill text-[10px]"></i> Live }
      </button>
    </div>
  </div>

  @if (noAnswer) {
  <p
    class="border-b border-gray-100 bg-yellow-50 px-4 py-1.5 text-xs text-yellow-800 dark:border-gray-700"
  >
    La OLT no respondió; se muestran los últimos valores leídos.
  </p>
  }

  <!-- niveles Rx -->
  <div class="grid grid-cols-1 gap-3 px-4 py-3 sm:grid-cols-2">
    @for (meter of meters; track meter.name) {
    <div
      class="rounded-lg border border-gray-100 bg-gray-50/60 p-3 dark:border-gray-700 dark:bg-gray-900/40"
    >
      <div class="flex items-baseline justify-between gap-2">
        <span
          class="whitespace-nowrap text-xs font-medium text-gray-600 dark:text-gray-300"
          [title]="meter.direction"
          >{{ meter.name }}</span
        >
        <span class="hidden whitespace-nowrap text-[11px] text-gray-400 xl:inline"
          >{{ meter.direction }}</span
        >
      </div>
      <div class="mt-1 flex items-baseline gap-1">
        <span class="text-2xl font-bold tabular-nums" [style.color]="meter.color || '#9ca3af'">
          {{ meter.value === null ? '–' : meter.value.toFixed(2) }}
        </span>
        @if (meter.value !== null) {
        <span class="text-xs text-gray-500">dBm</span>
        }
        <span
          class="ml-auto rounded-full px-2 py-0.5 text-[11px] font-semibold"
          [style.color]="meter.color || '#6b7280'"
          [style.background]="(meter.color || '#9ca3af') + '1a'"
        >
          {{ meter.level }}
        </span>
      </div>
      <!-- barra con la escala de SmartOLT (-36 a -12 dBm); el color cambia en cada umbral -->
      <div class="relative mb-1 mt-3">
        <div
          class="h-2 rounded-full"
          [style.background]="meter.value === null ? '#e5e7eb' : barBackground"
        ></div>
        @if (meter.position >= 0) {
        <span
          class="absolute top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow ring-1 ring-gray-400"
          [style.left.%]="meter.position"
          [style.background]="meter.color"
        ></span>
        }
      </div>
    </div>
    }
  </div>

  <!-- detalle óptico -->
  <button
    type="button"
    class="flex w-full items-center justify-between border-t border-gray-100 px-4 py-2 text-xs font-medium text-gray-500 transition hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-700/50"
    (click)="expanded = !expanded"
  >
    <span>
      Detalle óptico @if (quality) { · Señal
      <strong [style.color]="colorOf(signal.onu_signal_rx1490)">{{ quality }}</strong>
      }
    </span>
    <i class="pi text-xs" [ngClass]="expanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
  </button>
  @if (expanded) {
  <div class="px-4 pb-3">
    <table class="w-full text-xs" aria-describedby="Detalle óptico">
      <thead class="text-gray-400">
        <tr class="border-b border-gray-100 dark:border-gray-700">
          <th class="py-1.5 text-left font-medium"></th>
          <th class="py-1.5 text-right font-medium">Tx (dBm)</th>
          <th class="py-1.5 text-right font-medium">Rx (dBm)</th>
          <th class="py-1.5 text-right font-medium">Atenuación (dB)</th>
        </tr>
      </thead>
      <tbody class="text-gray-700 dark:text-gray-200">
        <tr class="border-b border-gray-50 dark:border-gray-700/50" title="OLT → ONU">
          <td class="py-1.5"><i class="pi pi-arrow-down text-[10px] text-gray-400"></i> 1490nm</td>
          <td class="py-1.5 text-right tabular-nums">{{ format(signal.olt_tx_power) }}</td>
          <td
            class="py-1.5 text-right font-semibold tabular-nums"
            [style.color]="colorOf(signal.onu_signal_rx1490)"
          >
            {{ format(signal.onu_signal_rx1490) }}
          </td>
          <td class="py-1.5 text-right tabular-nums">{{ format(signal.downstream_loss_db) }}</td>
        </tr>
        <tr title="ONU → OLT">
          <td class="py-1.5"><i class="pi pi-arrow-up text-[10px] text-gray-400"></i> 1310nm</td>
          <td class="py-1.5 text-right tabular-nums">{{ format(signal.onu_tx_power) }}</td>
          <td
            class="py-1.5 text-right font-semibold tabular-nums"
            [style.color]="colorOf(signal.onu_signal_rx1310)"
          >
            {{ format(signal.onu_signal_rx1310) }}
          </td>
          <td class="py-1.5 text-right tabular-nums">{{ format(signal.upstream_loss_db) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-gray-500">
      <span
        ><span class="mr-1 inline-block h-2 w-2 rounded-full bg-[#f97316]"></span>Advertencia ≤ {{
        signal.signal_limit_warning }} dBm</span
      >
      <span
        ><span class="mr-1 inline-block h-2 w-2 rounded-full bg-[#ef4444]"></span>Crítica ≤ {{
        signal.signal_limit_critical }} dBm</span
      >
      @if (signal.last_status_down_cause) {
      <span>Última causa de caída: {{ signal.last_status_down_cause }}</span>
      }
    </div>
  </div>
  }
</div>
